<template>
    <div class="information-box">
        <div class="md-layout">
            <div class="md-layout-item">
                <md-field>
                    <label>Payment Method</label>
                    <md-select
                        v-model="detail.paymentDetails.paymentMethod"
                        @md-selected="getSelectedPaymentMethod"
                        :disabled="disabled"
                    >
                        <md-option v-for="(item, index) in paymentMethodOptions" :key="index" :value="item">
                            {{ item }}
                        </md-option>
                    </md-select>
                </md-field>
            </div>
        </div>
        <div class="md-layout" v-show="displayPaymentMethod">
            <div class="md-layout-item">
                <form-group
                    name="paymentDetails.bank.name"
                    label="Account Name *"
                    :messages="{ required: 'Account Name is required' }"
                >
                    <md-input v-model="detail.paymentDetails.bank.name" />
                </form-group>
            </div>
            <div class="md-layout-item">
                <form-group name="paymentDetails.bank.bsb" label="BSB *" :messages="{ required: 'BSB is required' }">
                    <md-input v-model="detail.paymentDetails.bank.bsb" />
                </form-group>
            </div>
            <div class="md-layout-item">
                <form-group
                    name="paymentDetails.bank.accountNumber"
                    label="Account Number *"
                    :messages="{ required: 'Account Number is required' }"
                >
                    <md-input v-model="detail.paymentDetails.bank.accountNumber" />
                </form-group>
            </div>
            <div v-if="showRemittance" class="md-layout-item">
                <form-group
                    name="paymentDetails.bank.remittance"
                    label="Remittance Email"
                    :messages="{ email: 'Please enter a valid email address' }"
                >
                    <md-input v-model="detail.paymentDetails.bank.remittance" :disabled="disabled" />
                </form-group>
            </div>
            <div v-if="showPhoneNumber" class="md-layout-item">
                <form-group name="paymentDetails.phoneNumber" label="Phone Number">
                    <md-input v-model="detail.paymentDetails.phoneNumber" :disabled="disabled" />
                </form-group>
            </div>
        </div>
    </div>
</template>

<script>
import { PAYMENT_METHOD_CONSTANTS } from '@/utils/constants';

export default {
    name: 'PaymentMethodInputs',
    props: {
        detail: {
            type: Object,
            default: () => {}
        },
        showRemittance: {
            type: Boolean,
            default: false
        },
        showPhoneNumber: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        validator: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            paymentMethodOptions: PAYMENT_METHOD_CONSTANTS,
            displayPaymentMethod: null
        };
    },
    watch: {
        'detail.paymentDetails.paymentMethod': function(newVal) {
            this.getSelectedPaymentMethod(newVal);
        }
    },
    methods: {
        getSelectedPaymentMethod(value) {
            this.displayPaymentMethod = value === 'Bank Transfer';
        }
    }
};
</script>
